var utils = require('lib/utils');

var EnrollmentService = function() {
  this.parseEnrollment = function(model, response){
    let enrollment = utils.sanifyJsonApiObject(response.data, response.included);
    model.data.set(enrollment.enrollment_data);
    delete enrollment.enrollment_data;
    return enrollment;
  };

  this.saveData = function(model, options, dataObj){
    model.save();
  };
};

module.exports = new EnrollmentService();